import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RingLoader } from "react-spinners";
import Backicon from "../../../shared/components/Backicon/Backicon";
import Tile from "../../../shared/components/Tile/Tile";
import styles from "./hospitalprofile.module.css";
import baseStyles from "../../../shared/styles/basestyles.module.css";

function HospitalProfile() {
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 3000);
  }, []);

  return (
    <div className={styles.hospitalhome}>
      <div className={baseStyles.container}>
        {pageLoading ? (
          <div className={styles.spinnerContainer}>
            <RingLoader size={100} color={"white"} />
          </div>
        ) : (
          <div>
            <Backicon onClick={() => this.props.history.goBack()} />
            <h1 className={styles.title}>Hospital Profile</h1>
            <div className={styles.first}>
              <Link to="/hospital/doctor-appointments">
                <Tile
                  name="Doctor's Appointments"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/hospital/hospital-access">
                <Tile
                  name="Patient Details Record"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
              <Link to="/hospital/patients-expense-report">
                <Tile
                  name="Patient's Expense Report"
                  style={{
                    height: "200px",
                    width: "250px",
                    fontSize: "2.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.619)",
                  }}
                />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default HospitalProfile;
